import { render, staticRenderFns } from "./qualityTaskForm.vue?vue&type=template&id=2ce10157&scoped=true"
import script from "./qualityTaskForm.vue?vue&type=script&lang=js"
export * from "./qualityTaskForm.vue?vue&type=script&lang=js"
import style0 from "./qualityTaskForm.vue?vue&type=style&index=0&id=2ce10157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce10157",
  null
  
)

export default component.exports